import { NB } from '@cerebral-inc/ui';
import { Checkbox } from 'components/shared/checkbox/CheckBox';

const { Box, useMediaQuery } = NB;

export interface ITermAndCondition {
  checked: boolean;
  onChange: () => void;
}

export const TermAndCondition = ({ checked, onChange }: ITermAndCondition) => {
  const [isMediumMobile] = useMediaQuery({ minWidth: 415, maxWidth: 768 });
  return (
    <Box
      position={isMediumMobile ? 'absolute' : 'unset'}
      bottom="88px"
      pb={{ base: '24px', md: '0' }}
    >
      <Box pt="15px">
        <Checkbox checked={checked} onChange={onChange}>
          I accept the{' '}
          <a
            href="https://cerebral.com/hipaa-marketing-authorization"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#385ADE' }}
          >
            Cerebral HIPAA Marketing Authorization
          </a>
          .
        </Checkbox>
      </Box>
    </Box>
  );
};
